/**
 * The plan timeline's labels, as translation keys.
 *
 * The API writes them in English ("Day 3", "Morning", "Full day (day 2 of
 * 3)") because they are also machine keys it counts meals by, and the web
 * and the app printed them as they came: "Day 1", "MORNING" over German,
 * Dutch and Spanish plans (2026-11-01 itinerary tests). Each client turns
 * them into its own key with these, and anything unknown prints as written.
 */
export type PlanLabel = { key: string; params?: Record<string, number> };

const SLOT_KEYS: Record<string, string> = {
  morning: "morning",
  lunch: "lunch",
  midday: "lunch",
  afternoon: "afternoon",
  dinner: "dinner",
  evening: "evening",
  "full day": "full_day",
  also: "also",
};

/** "Day 3" → `day` with n = 3. */
export function planDayLabel(label: string): PlanLabel | null {
  const m = /^\s*day\s+(\d{1,2})\s*$/i.exec(label);
  return m ? { key: "day", params: { n: Number(m[1]) } } : null;
}

/** "Morning" → `slot.morning`; "Full day (day 2 of 3)" → `slot.full_day_part`. */
export function planSlotLabel(time: string): PlanLabel | null {
  const part = /^\s*full day \(day (\d{1,2}) of (\d{1,2})\)\s*$/i.exec(time);
  if (part) return { key: "slot.full_day_part", params: { k: Number(part[1]), n: Number(part[2]) } };
  const key = SLOT_KEYS[time.trim().toLowerCase()];
  return key ? { key: `slot.${key}` } : null;
}
